import { Injectable } from '@angular/core';

import { AsyncJobType } from '@recruitee/account-data';
import { AsyncJobConfig } from '@recruitee/async-job';
import { NotificationStyle } from '@recruitee/user-interface';

@Injectable()
export class BulkEEODataRequestAsyncJob implements AsyncJobConfig {
  public readonly type = AsyncJobType.BulkEEODataRequest;
  public readonly showDialog = false;
  public readonly showNotification = true;
  public readonly translations = {
    title: {
      success: 'app.async_jobs.bulk_eeo_data_request.title.success',
      progress: 'app.async_jobs.bulk_eeo_data_request.title.progress',
    },
  };
  public readonly skipNotificationMessages = true;
  public readonly skipProgressBar = true;
  public readonly workingNotificationStyle = NotificationStyle.InProgress;
}
